var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-table__cell",attrs:{"title":_vm.cellValue}},[_c('span',[_vm._v("\n    "+_vm._s(_vm.cellValue)+" \n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }